/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';

const Button = ({ type, buttonText, to, disabled, onClick, ...props }) => {
    if (to) {
        return (
            <Styled.ButtonLink
                {...props}
                disabled={disabled}
                to={to}
                type={type}
                onClick={
                    onClick ||
                    (e => {
                        if (disabled) {
                            e.preventDefault();
                        }
                    })
                }
            >
                {buttonText}
            </Styled.ButtonLink>
        );
    }
    return (
        <Styled.Button
            disabled={disabled}
            type={type}
            onClick={
                onClick ||
                (e => {
                    if (disabled) {
                        e.preventDefault();
                    }
                })
            }
        >
            <Styled.ButtonText>{buttonText}</Styled.ButtonText>
        </Styled.Button>
    );
};

Button.defaultProps = {
    to: null,
    onClick: null
};

Button.propTypes = {
    type: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    to: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool.isRequired
};

export default Button;
